import Vue from "vue";
/* Observable responsável por gerenciar as urls do wc. Dinamicas de acordo com o Grupo (props) */
export const urlObservable = Vue.observable({
  tileServer: "",
  backServer: "",
  backServerInterpolation: "",
  backServerInterpolationOnDemand: ""
});
